import PropTypes from 'prop-types';
import { Error, InlineAnchor, Typography } from '@figure/frontlib-gui';
import { useTranslation } from 'react-i18next';
import { LI, OL } from 'shared/components/List';
import { Instruction, InstructionButtonGroup } from './';

const TaxInstruction = ({ handleBack, handleClick, serverError }) => {
  const [t] = useTranslation('translation');
  return (
    <Instruction space="1.6rem">
      <Typography.BodyBold semanticElement="h2">What you’ll need:</Typography.BodyBold>

      <Typography.Body>
        Login credentials to your tax preparation service or{' '}
        <InlineAnchor href="https://irs.gov" target="_blank" rel="noopener noreferrer">
          IRS.gov
        </InlineAnchor>{' '}
        account
      </Typography.Body>

      <Typography.Body>OR</Typography.Body>

      <Typography.Body>Create an IRS.gov account with the following easy steps:</Typography.Body>

      <OL resetMargin={false} space="0">
        <LI>
          Access{' '}
          <InlineAnchor href="https://irs.gov" target="_blank" rel="noopener noreferrer">
            IRS.gov
          </InlineAnchor>
        </LI>
        <LI>Select "Get your tax record"</LI>
        <LI>Select "Get transcript online"</LI>
        <LI>Follow the prompt to quickly set up an account</LI>
        <LI>
          Return back to your {t('companySingleName')} application and verify your income by logging into{' '}
          <InlineAnchor href="https://irs.gov" target="_blank" rel="noopener noreferrer">
            IRS.gov
          </InlineAnchor>{' '}
          with your new credentials
        </LI>
      </OL>

      <Typography.Body>
        Once you link your account, we’ll ask you to allow us access to your return from the most recent tax year.
      </Typography.Body>

      <Error display="block">{serverError}</Error>

      <InstructionButtonGroup buttonText="Link tax returns" handleBack={handleBack} handleClick={handleClick} />
    </Instruction>
  );
};

TaxInstruction.propTypes = {
  handleBack: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
  serverError: PropTypes.string.isRequired,
};

export default TaxInstruction;
